import fetch from '@/utils/fetch'

/**
 *文件下载
 * @export
 * @param {*} id
 * @returns
 */
export function downLoadFile(url) {
    const path = process.env.VUE_APP_INTERFACEADDRESS
    console.log(path)
    window.open(path + url, '_blank')
}
/**
 *获取文件列表
 * @export
 * @param {*} data
 * @returns
 */
export function getfileList(data) {
    return fetch.request({
        url: '/file/files/type',
        method: 'post',
        data
    })
}

/**
 *删除文件api
 * @export
 * @param {*} data
 * @returns
 */
export function fileRemove(data) {
    return fetch.request({
        url: '/file/delete/' + data.pkId,
        method: 'delete',
        data
    })
}
/**
 *删除文件
 * @export
 * @param {*} data
 * @returns
 */
export function fileRemoveOperate(item) {
    fileRemove(item)
        .then(res => {
            this.getfileLists()
        }).catch(() => {})
}

/**
 *获取文件列表
 * @export
 * @param {*} data
 * @returns
 */
export function getfileLists() {
    let data = {
        businessId: this.uploadBusinessId,
        typeCode: this.typeCode
    }
    getfileList(data)
        .then(res => {
            if (res) {
                this.fileList = res
            }
        }).catch(() => {})
}
/**
 *上传文件成功回调
 * @export
 * @param {*} data
 * @returns
 */
export function uploadSuccess(response, file, fileList) {
    this.getfileLists()
}

/**
 *无其他限制文件上传
 * @export
 * @param {*} data
 * @returns
 */
export function beforeUpload(file) {
    let flag = true
    this.fileList.forEach(item => {
        if (item.fileName == file.name) {
            flag = false
            this.fileFlag = false
            this.$message({
                showClose: true,
                message: '不能上传相同的文件',
                type: 'error',
                duration: '1000'
            })
        }
    })
    this.uploadData.businessId = this.uploadBusinessId // 业务ID
    this.uploadData.typeCode = this.typeCode // 模块类型
    this.uploadData.file.push(file)
    return flag
}

/**
 *只是图片上传
 * @export
 * @param {*} data
 * @returns
 */
export function imgBeforeUpload(file) {
    let flag = true
    this.fileList.forEach(item => {
        if (item.fileName == file.name) {
            flag = false
            this.$message({
                showClose: true,
                message: '不能上传相同的文件',
                type: 'error',
                duration: '1000'
            })
        }
    })
    let fileType = file.type.split('/')[0]
    let fileFlag = fileType === 'image'
    if (!fileFlag) {
        this.$message({
            showClose: true,
            message: '只能上传图片，请重新上传',
            type: 'error',
            duration: '1000'
        })
    }
    this.uploadData.businessId = this.uploadBusinessId // 业务ID
    this.uploadData.typeCode = this.typeCode // 模块类型
    this.uploadData.file.push(file)
    return flag && fileFlag
}

/**
 *限定文件类型和大小的文件
 * @export
 * @param {*} data
 * @returns
 */
export function specialBeforeUpload(file) {
    let flag = true
    this.fileList.forEach(item => {
        if (item.fileName == file.name) {
            flag = false
            this.$message({
                showClose: true,
                message: '不能上传相同的文件',
                type: 'error',
                duration: '1000'
            })
        }
    })

    let fileName = file.name
    let fileTypeArr = fileName.split('.')
    let fileType = fileTypeArr[fileTypeArr.length - 1].toLowerCase()
    // let regex = /^(rar|zip|doc|docx|pdf)$/
    let regex = /^(exe|com|bat|cmd|int|sys|dll|adt)$/

    const fileFlag = !(regex.test(fileType))
    let isLtKB
    //   检验文件格式
    if (!fileFlag) {
        this.$message({
            showClose: true,
            message: '不支持exe、com 、bat、cmd、int、sys、dll、adt文件格式',
            type: 'error',
            duration: '1000'
        })
    } else {
        //  检验文件大小
        isLtKB = file.size / 1024 <= 500
        if (!isLtKB) {
            this.$message({
                showClose: true,
                message: '上传文件大小不能超过500kb，请重新上传！',
                type: 'error',
                duration: '1000'
            })
        }
    }
    this.uploadData.businessId = this.uploadBusinessId // 业务ID
    this.uploadData.typeCode = this.typeCode // 模块类型
    this.uploadData.file.push(file)
    return flag && fileFlag && isLtKB
}

/**
 *限定文件类型和大小的文件 -- 大文件版本
 * @export
 * @param {*} data
 * @returns
 */
export function specialBeforeUploadBig(file) {
    let flag = true
    this.fileList.forEach(item => {
        if (item.fileName == file.name) {
            flag = false
            this.$message({
                showClose: true,
                message: '不能上传相同的文件',
                type: 'error',
                duration: '1000'
            })
        }
    })

    let fileName = file.name
    let fileTypeArr = fileName.split('.')
    let fileType = fileTypeArr[fileTypeArr.length - 1].toLowerCase()
    // let regex = /^(rar|zip|doc|docx|pdf)$/
    let regex = /^(exe|com|bat|cmd|int|sys|dll|adt)$/

    const fileFlag = !(regex.test(fileType))
    let isLtKB
    //   检验文件格式
    if (!fileFlag) {
        this.$message({
            showClose: true,
            message: '不支持exe、com 、bat、cmd、int、sys、dll、adt文件格式',
            type: 'error',
            duration: '1000'
        })
    } else {
        //  检验文件大小
        isLtKB = file.size / 1024 <= 100000
        if (!isLtKB) {
            this.$message({
                showClose: true,
                message: '上传文件大小不能超过100M，请重新上传！',
                type: 'error',
                duration: '1000'
            })
        }
    }
    this.uploadData.businessId = this.uploadBusinessId // 业务ID
    this.uploadData.typeCode = this.typeCode // 模块类型
    this.uploadData.file.push(file)

    return flag && fileFlag && isLtKB
}
